import { render } from "./TrackerCard.vue?vue&type=template&id=7bc12dda"
import script from "./TrackerCard.vue?vue&type=script&lang=js"
export * from "./TrackerCard.vue?vue&type=script&lang=js"
script.render = render

export default script